import { commonFilter } from './filter';

export default {
  pageName: 'Keyword Analysis',
  pageId: '25080',
  pagePath: '/opinion/AIAnalysisHub/KeywordAnalysis',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
    KeywordSearchType: {
      buttonId: '2508001',
    },
    // GPT_Type: {
    //   buttonId: '2508002',
    // },
    EditPrompt: {
      buttonId: '2508003',
    },
    TypeTAB: {
      buttonId: '2508004',
    },
    GPTRegenerate: {
      buttonId: '2508007',
    },
    GPTCopy: {
      buttonId: '2508008',
    },
    GPTFullScreen: {
      buttonId: '2508009',
    },
    GotoFeeds: {
      buttonId: '2508010',
    },
    ReviewTypeTAB: {
      buttonId: '2508012',
    },
    SentimentStatisticsTAB: {
      buttonId: '2508013',
    },
    GPT_Get_Btn: {
      buttonId: '2508026',
    },
    GPT_Confirm: {
      buttonId: '2508027',
    },
    GPT_Stop: {
      buttonId: '2508028',
    },
    GPT_Agent: {
      buttonId: '2508029',
    },
    SelectVideoSummary: {
      buttonId: '2508030',
    },
    SelectCommentSummary: {
      buttonId: '2508031',
    },
    GPT_Options: {
      buttonId: '2508032',
    },
    GenerateReport: {
      buttonId: '2508033',
    },
    RegularListening: {
      buttonId: '2508034',
    },
    RegularListeningConfirm: {
      buttonId: '2508035',
    },
  },
  card: {
    ChartCard: {
      bar: {
        buttonId: '2508014',
      },
      line: {
        buttonId: '2508015',
      },
      pie: {
        buttonId: '2508016',
      },
      table: {
        buttonId: '2508017',
      },
      'sentiment-s-bar': {
        buttonId: '2508018',
      },
      'common-bar': {
        buttonId: '2508019',
      },
      stack_line: {
        buttonId: '2508020',
      },
      download: {
        buttonId: '2508021',
      },
    },
    GPT: {
      refresh: {
        buttonId: '2508022',
      },
      copy: {
        buttonId: '2508023',
      },
      fullscreen: {
        buttonId: '2508024',
      },
      save: {
        buttonId: '2508025',
      },
    },
  },
};
